import ufeApi from 'services/api/ufeApi';
import RCPSCookies from 'utils/RCPSCookies';
import UserUtils from 'utils/User';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Switch+Country+API

function switchCountry(switchToCountry, languageCode) {
    let url = '/api/users/profile/switchCountry';
    const isUserAnonymous = UserUtils.isAnonymous();
    const isRCPSProfileBiGroupAPIEnabled = RCPSCookies.isRCPSProfileBiGroupAPIEnabled();

    if (isRCPSProfileBiGroupAPIEnabled && !isUserAnonymous) {
        url = '/gway/v2/users/profile/switchCountry';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify({
                switchToCountry,
                languageCode
            })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default switchCountry;
